class LocalStorageService {
  set(key, value) {
    if (!key) return;
    try {
      const serialized = typeof value === "string" ? value : JSON.stringify(value);
      window.localStorage.setItem(key, serialized);
    } catch (e) {
      // noop
    }
  }

  get(key, defaultValue = null) {
    if (!key) return defaultValue;
    try {
      const raw = window.localStorage.getItem(key);
      if (raw == null) return defaultValue;
      try {
        return JSON.parse(raw);
      } catch (_) {
        return raw;
      }
    } catch (e) {
      return defaultValue;
    }
  }
}

const storage = new LocalStorageService();

export default storage;

